/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_404_LeadInputs */

const en_mk_sol_404_lead = /** @type {(inputs: Mk_Sol_404_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We have written six illustrated examples so far. Pick whichever is closest to your business — the pattern transfers.`)
};

const id_mk_sol_404_lead = /** @type {(inputs: Mk_Sol_404_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kami baru menulis enam contoh penerapan. Pilih yang paling dekat dengan usaha Anda — polanya bisa dipindahkan.`)
};

/**
* | output |
* | --- |
* | "We have written six illustrated examples so far. Pick whichever is closest to your business — the pattern transfers." |
*
* @param {Mk_Sol_404_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_404_lead = /** @type {((inputs?: Mk_Sol_404_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_404_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_404_lead(inputs)
	return en_mk_sol_404_lead(inputs)
});